/**
 * Third-party sign-in provider marks.
 *
 * These are the providers' own brand marks, not UI icons, so they sit outside
 * the Streamline Core system the way our logo does: Google's and Apple's
 * sign-in branding guidelines require their unaltered marks on these buttons
 * (Google's four-colour "G"; Apple's logo in black on a white button). They are
 * static files in `public/brand/providers/` rather than inline SVG because `/login` ships
 * in the landing page's eager bundle, where their path data would cost budget.
 * Decorative here — the button carries the accessible name.
 */

import { PasskeyIcon } from '@/components/icons/line/passkey';

export function GoogleMark({ className }: { className?: string }) {
  return (
    <img src="/brand/providers/google.svg" alt="" width={18} height={18} className={className} />
  );
}

export function AppleMark({ className }: { className?: string }) {
  return (
    <img src="/brand/providers/apple.svg" alt="" width={18} height={18} className={className} />
  );
}

/** Streamline Core passkey glyph sized to match the 18px OAuth provider marks. */
export function PasskeyMark({ className }: { className?: string }) {
  return <PasskeyIcon size={18} className={className} aria-hidden />;
}
